import { Title } from '~/components/shared/Text'

export const DealerTitle = ({ data }) => {
  return (
    <Title
      m={{ xs: '15%', md: '5%' }}
      variant="h1"
      style={{ color: 'white', textAlign: 'center' }}
    >
      {data.name}
    </Title>
  )
}
